
const TermsConditions = () => {
  return (
    <section className="policy-page">

      <div className="container">

        <div className="policy-header">


          <h1>Terms & Conditions</h1>

          <p>
            Effective Date: August 2, 2026
          </p>

        </div>

        <div className="policy-content">

          <section>

            <h2>1. Acceptance</h2>

            <p>
              By using this website you agree to these Terms & Conditions.
              If you disagree with any part of these terms, please discontinue
              use of the website.
            </p>

          </section>

          <section>

            <h2>2. Our Services</h2>

            <p>
              Swanora Global provides import and export services including
              product sourcing, documentation, logistics coordination,
              international trade consulting, and supply chain support.
            </p>

          </section>

          <section>

            <h2>3. Quotations</h2>

            <p>
              All quotations are subject to product availability, exchange
              rates, shipping charges, taxes, customs duties, and supplier
              pricing until confirmed in writing.
            </p>

          </section>

          <section>

            <h2>4. Orders</h2>

            <p>
              Orders become valid only after written confirmation by
              Swanora Global.
            </p>

          </section>

          <section>

            <h2>5. Shipping</h2>

            <p>
              Delivery timelines are estimates and may vary because of customs
              clearance, weather, transportation delays, government regulations,
              or other circumstances beyond our control.
            </p>

          </section>

          <section>

            <h2>6. International Compliance</h2>

            <p>
              Buyers are responsible for ensuring products comply with import
              regulations in their destination country.
            </p>

          </section>

          <section>

            <h2>7. Intellectual Property</h2>

            <p>
              All website content including logos, graphics, images, text,
              branding, and designs remain the intellectual property of
              Swanora Global.
            </p>

          </section>

          <section>

            <h2>8. Limitation of Liability</h2>

            <p>
              Swanora Global shall not be liable for indirect, incidental,
              consequential, or business losses resulting from the use of this
              website or our services.
            </p>

          </section>

          <section>

            <h2>9. Governing Law</h2>

            <p>
              These Terms shall be governed by the laws of India. Any disputes
              shall be subject to the jurisdiction of the courts in Maharashtra, India
            </p>

          </section>

          <section>

            <h2>10. Contact</h2>

            <p><strong>Swanora Global</strong></p>
            <p>Email: info@swanoraglobal.com</p>
            <p>Pune, Maharashtra, India</p>

          </section>

        </div>

      </div>

    </section>
  );
};

export default TermsConditions;